
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Layer_1","data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 281.57 281.5"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4633,1928.8a84.39,84.39,0,0,0-119.21,0,2.2,2.2,0,1,0,3.11,3.1,80,80,0,0,1,113,0,2.2,2.2,0,0,0,3.1,0,2.2,2.2,0,0,0,0-3.1Zm0,0","transform":"translate(-4432.59 -1806.33)","fill":"#fff","stroke":"#3b7cf7","stroke-miterlimit":"10"}}),_c('path',{attrs:{"d":"M4526.71,1941.69a2.2,2.2,0,0,0,0,3.11,2.18,2.18,0,0,0,3.09,0,61.74,61.74,0,0,1,87.21,0,2.17,2.17,0,0,0,3.09,0,2.2,2.2,0,0,0,0-3.11,66.13,66.13,0,0,0-93.39,0Zm0,0","transform":"translate(-4432.59 -1806.33)","fill":"#fff","stroke":"#3b7cf7","stroke-miterlimit":"10"}}),_c('path',{attrs:{"d":"M4573.41,1940.61a47.49,47.49,0,0,0-33.8,14,2.2,2.2,0,0,0,0,3.11,2.17,2.17,0,0,0,3.09,0,43.49,43.49,0,0,1,61.41,0,2.18,2.18,0,0,0,1.55.64,2.14,2.14,0,0,0,1.54-.64,2.2,2.2,0,0,0,0-3.11,47.47,47.47,0,0,0-33.79-14Zm0,0","transform":"translate(-4432.59 -1806.33)","fill":"#fff","stroke":"#3b7cf7","stroke-miterlimit":"10"}}),_c('path',{attrs:{"d":"M4573.41,1961.26a14.38,14.38,0,1,0,14.37,14.38,14.4,14.4,0,0,0-14.37-14.38Zm0,24.36a10,10,0,1,1,10-10,10,10,0,0,1-10,10Zm0,0","transform":"translate(-4432.59 -1806.33)","fill":"#fff","stroke":"#3b7cf7","stroke-miterlimit":"10"}}),_c('circle',{attrs:{"cx":"140.82","cy":"140.75","r":"125.75","fill":"none","stroke":"#fff","stroke-miterlimit":"10","stroke-width":"30"}}),_c('path',{staticClass:"pieChart",attrs:{"d":"M4578,1821.43c-1.54-.06-3.09-.1-4.64-.1a125.75,125.75,0,1,0,43.33,243.84","transform":"translate(-4432.59 -1806.33)","fill":"none","stroke":"#000","stroke-miterlimit":"10","stroke-width":"30"}})])
          )
        }
      }
    